import React, {useEffect, useState, useRef} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import IconPrint from '../../../../../../components/icon/IconPrint'
import IconDownload from '../../../../../../components/icon/IconDownload'
import PdfPreview from './PdfPreview'
import EmailForm from './EmailForm'
import {downloadImage, downloadPdf, downloadPjSuppl, generateDevisPdf} from '../../../../../../components/requests'
import {toast} from 'react-toastify'
import {useReactToPrint} from 'react-to-print'
import ReactQuill from 'react-quill'
import {useAuth} from '../../../../../modules/auth'
import moment from 'moment/moment'
import axios from 'axios'
import error = toast.error
import isEqual from 'lodash/isEqual'
import {Modal} from 'react-bootstrap'

const API_URL = process.env.REACT_APP_API_URL
const DEMANDE_BASE_URL = `${API_URL}/demande`
const ShopDevis = (props) => {
  const {
    libelleList,
    setHasLibelleChanged,
    panier,
    demandeId,
    dataClientInfos,
    pieces,
    setDisableBtn,
    clientId,
    setPanier,
    redirectDemandeListPage,
    redirectToClientDemande,
    demandeClient,
    setDemandeClient,
    setPiecesProps,
    setLoadStock,
    fullLibelleData,
    otherData,
    filters,
    onResendPropo,
    setLoadingRenvoiPropos,
    piecesProposeesModifiees,
    setPiecesProposesModifiees,
    setCheckedPieces,
    piecesProposeesChecked,
    setPiecesProposeesChecked,
    adresseFacturation,
    historiqueDevis,
    loadingHistoryDevis,
    displayHistory,
    updatedFinalAdresseFactInfo,
    updatedFinalAdresseLivInfo,
    setOpenModalDevis,
    openModalDevis,
    setInitialPieces,
    mailContent,
    onMailContentChange,
    retraitDepot,
    getAdresseRetraitDepot = () => {},
    commentaireInterne,
    setCommentaireInterne,
    associations,
    activeHistorique,
    setActiveHistorique = () => {},
    clientContacts,
    isAdresseUpdated,
    setUpdatedAdresseLivInfo,
    setUpdatedAdresseFactInfo,
  } = props
  const date = new Date()
  const now = date.toLocaleDateString()
  const [dateStr] = useState(
      `${date?.getFullYear() ?? ''}` +
      `${String((date?.getMonth() ?? 0) + 1).padStart(2, '0')}` +
      `${String(date?.getDate() ?? 0).padStart(2, '0')}` +
      `${String(date?.getHours() ?? 0).padStart(2, '0')}` +
      `${String(date?.getMinutes() ?? 0).padStart(2, '0')}` +
      `${String(date?.getSeconds() ?? 0).padStart(2, '0')}`
  )
  const contentRef = useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({contentRef})
  // const aProposerPanier = panier.filter((item) => item.statut === 'A_PROPO')
  const [loadingPJ, setloadingPJ] = useState<boolean>(false)
  const [fileName, setFileName] = useState<any>('')
  const [aProposerPanier, setAProposerPanier] = useState<any>([])
  const [disableBtnT, setDisableBtnT] = useState<boolean>(false)
  const modalRef = useRef<HTMLDivElement | null>(null)
  const quillRef = useRef<ReactQuill | null>(null)
  const [dataVehicule, setDataVehicule] = useState<any>([])

  const [isShown, setIsShown] = useState<any>(false)


  const {currentUser} = useAuth() //utilisateur connecté
  const abortControllerRef = useRef<AbortController | null>(null)
  const prevData = useRef({
    aProposerPanier,
    libelleList,
    dataClientInfos,
    updatedFinalAdresseFactInfo,
    updatedFinalAdresseLivInfo,
  })
  const [totalDevis, setTotalDevis] = useState<any>({
    totalHT: '',
    totalTTC: '',
    totalTransportHT: '',
    totalTransportTTC: '',
  })

  const numeroOffre = displayHistory
      ? `DEV-${moment(historiqueDevis?.[activeHistorique]?.dateCreation).format(
          'YYYYMMDDhhmmss'
      )}${demandeId}`
      : `DEV-${dateStr}${demandeId}`
  const utilisateurAssigne = displayHistory
      ? historiqueDevis?.[activeHistorique]?.utilisateurAssigne
      : currentUser
  const client = displayHistory ? historiqueDevis?.[activeHistorique]?.client : dataClientInfos
  const nomFichier = displayHistory ? historiqueDevis?.[activeHistorique]?.nomFichier : fileName

  const [pieceJointeSuppl, setPieceJointeSuppl] = useState<any>(displayHistory ? historiqueDevis?.[activeHistorique]?.pieceJointeSupplementaire : [])

  // fonction qui permet de verifier si la source est "auto" , "moto" , "industrie"
  const computeSources = () => {
    let isAuto = false
    let isMoto = false
    let isIndus = false

    const sourcesUtilisateur: any = utilisateurAssigne?.listeSources?.[0] || []
    const countSourceUtilisateurs = sourcesUtilisateur.length

    // Codes client
    const codes = {
      AUTO: client?.codeClientAAuto ? 'AUTO' : null,
      MOTO: client?.codeClientAMoto ? 'MOTO' : null,
      INDUSTRIE: client?.codeClientAIndus ? 'INDUSTRIE' : null,
    }
    // Codes non null
    const codesNotNull = Object.values(codes).filter((v) => v !== null)
    const countCodeClientNotNull = codesNotNull.length

    let source: any = null

    if (
        countSourceUtilisateurs === 1 ||
        (countSourceUtilisateurs > 1 && countCodeClientNotNull > 1) ||
        (countSourceUtilisateurs > 0 && countCodeClientNotNull === 0)
    ) {
      source = sourcesUtilisateur[0]

      isAuto = source === 'AUTO'
      isMoto = source === 'MOTO'
      isIndus = source === 'INDUSTRIE'
    } else if (countCodeClientNotNull === 1 && countSourceUtilisateurs > 1) {
      source = codesNotNull[0]

      isAuto = source === 'AUTO'
      isMoto = source === 'MOTO'
      isIndus = source === 'INDUSTRIE'
    } else if (countSourceUtilisateurs === 0 && countCodeClientNotNull >= 1) {
      source = codesNotNull?.[0]

      isAuto = source === 'AUTO'
      isMoto = source === 'MOTO'
      isIndus = source === 'INDUSTRIE'
    } else {
      isAuto = true
    }

    return {isAuto, isMoto, isIndus, source}
  }

  const {isAuto, isMoto, isIndus, source} = computeSources()
  let sourceDemande = ''

  const getSourceDmd = () => {
    if (isAuto) sourceDemande = 'AUTO'
    else if (isMoto) sourceDemande = 'MOTO'
    else if (isIndus) sourceDemande = 'INDUSTRIE'
    getAdresseRetraitDepot(sourceDemande)
  }

  useEffect(
      function getAdresseRetraitDepotBySource() {
        getSourceDmd()
      },
      [client, utilisateurAssigne]
  )

  // useEffect(function refetchRetraitDepot() {
  //   if (retraitDepot)
  //     getSourceDmd()
  // }, []);

  // Re-rendu des pieces si "Génerer le devis ou renvoi de proposition"
  useEffect(() => {
    const panierData = panier.map((item) => {
      if (item.immat === '') return {...item, immat: `${item?.marque} - ${item?.modele}`}
      return item
    })
    //prendre les paniers "A proposer" / "Proposer" / "Acceptée bloqueé" à envoyer dans le devis
    const aProposerPanier = panierData.filter(
        (item) => item.statut === 'A_PROPO' || item.statut === 'PROPO' || item.statut === "BLOQU"
    )

    if (aProposerPanier.length > 0) {
      //filtre sur le panier pour avoir les données vehicules sans doublon
      const dataVehicule = aProposerPanier
          .map((p) => ({
            immatriculation: p?.immat,
            marque: p?.marque,
            modele: p?.modele,
            cnit: p?.cnit,
            vin: p?.vin,
            isVHT: p?.isVHT,
          }))
          .filter(
              (vehicule, index, self) =>
                  index ===
                  self.findIndex(
                      (v) => v.immatriculation === vehicule.immatriculation && v.marque === vehicule.marque
                  )
          )
      setDataVehicule(dataVehicule)
      setAProposerPanier(aProposerPanier)
    }
  }, [panier])

  // fonction qui genere le pdf
  const generationDevisPdF = () => {
    // Annule la requête précédente si elle existe
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
    }
    const controller = new AbortController()
    abortControllerRef.current = controller

    const sources = computeSources()
    setloadingPJ(true)
    generateDevisPdf(
        aProposerPanier,
        libelleList,
        demandeId,
        dataClientInfos,
        dataVehicule,
        otherData,
        adresseFacturation,
        sources,
        retraitDepot,
        controller.signal
    )
        .then((response) => {
          if (response.status === 200) {
            const fileName = response?.data
            setFileName(fileName)
          }
          setloadingPJ(false)
        })
        .catch((error) => {
          if (axios.isCancel(error) || error.name === 'CanceledError') {
            return
          }
          console.error('erreur')
          setloadingPJ(false)
        })
  }

  //Générer le pdf si les données de pièce, de client, de libellé ou d'adresse de client changent + modal devis ouvert
  useEffect(
      function generateDevisOnDataChange() {
        const hasDataChanged = !isEqual(prevData.current, {
          aProposerPanier,
          libelleList,
          dataClientInfos,
          updatedFinalAdresseFactInfo,
          updatedFinalAdresseLivInfo,
        })

        if (openModalDevis && hasDataChanged && !displayHistory) {
          generationDevisPdF()
          prevData.current = {
            aProposerPanier,
            libelleList,
            dataClientInfos,
            updatedFinalAdresseFactInfo,
            updatedFinalAdresseLivInfo,
          } //Màj des valeurs précédentes pour le prochain rendu
        }
      },
      [
        aProposerPanier,
        libelleList,
        dataClientInfos,
        updatedFinalAdresseFactInfo,
        updatedFinalAdresseLivInfo,
        openModalDevis,
        displayHistory,
      ]
  )

  // Détection ouverture de modal
  useEffect(function openDevisModal() {
    const modal = modalRef.current

    const handleShown = () => {
      setIsShown(true)
    }

    const handleHidden = () => {
      setIsShown(false)
      setOpenModalDevis(false)
    }

    if (modal) {
      modal.addEventListener('shown.bs.modal', handleShown)
      modal.addEventListener('hidden.bs.modal', handleHidden)
    }

    return () => {
      if (modal) {
        modal.removeEventListener('shown.bs.modal', handleShown)
        modal.removeEventListener('hidden.bs.modal', handleHidden)
      }
    }
  }, [])


  // Lit le message d'erreur renvoyé par le serveur (la réponse d'erreur est aussi un ArrayBuffer)
  const parseErrorMessage = (error: any): string | null => {
    try {
      const data = error?.response?.data
      if (data instanceof ArrayBuffer) {
        const text = new TextDecoder('utf-8').decode(data)
        return JSON.parse(text)?.message ?? null
      }
      return data?.message ?? null
    } catch {
      return null
    }
  }

  // Déclenche le téléchargement d'une réponse axios (arraybuffer)
  const saveBlob = (
      response: any,
      fallbackName: string,
      fallbackType: string
  ) => {
    const contentType = response.headers['content-type'] || fallbackType
    const blob = new Blob([response.data], { type: contentType })

    // Nom envoyé par le serveur (Content-Disposition), sinon nom de secours sans chemin
    const disposition = response.headers['content-disposition'] || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    const fileName = match
        ? decodeURIComponent(match[1])
        : String(fallbackName).split('/').pop() || 'document'

    const fileURL = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = fileURL
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(fileURL)
  }

  const handleDownloadPdf = async (file: string, isPdf = true) => {
    if (!file) return

    setDisableBtnT(true)
    const idToast = toast.loading('Téléchargement en cours...')

    try {
      if (isPdf) {
        // 1. PDF du devis
        const pdfResponse = await downloadPdf(file)
        saveBlob(pdfResponse, file, 'application/pdf')

        // 2. Pièces jointes supplémentaires (fichier unique ou zip) => uniquement dans l'historique devis
        if(displayHistory){
          if (pieceJointeSuppl?.length > 0) {
            // petit délai : certains navigateurs bloquent 2 téléchargements simultanés
            await new Promise((resolve) => setTimeout(resolve, 500))

            const pjResponse = await downloadPjSuppl(pieceJointeSuppl , false)
            const fallbackName =
                pieceJointeSuppl.length === 1 ? pieceJointeSuppl[0] : 'pieces-jointes.zip'

            saveBlob(pjResponse, fallbackName, 'application/octet-stream')
          }
        }
      } else {
        // Image POT
        const imgResponse = await downloadImage(file)
        saveBlob(imgResponse, file, 'application/octet-stream')
      }

      toast.update(idToast, {
        render: 'Téléchargement effectué avec succès',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
    } catch (error) {
      const errorMsg =
          parseErrorMessage(error) ||
          (isPdf
              ? 'Erreur lors du téléchargement des pièces jointes'
              : "Erreur lors du téléchargement de l'image")

      console.error(errorMsg, error)
      toast.update(idToast, {
        render: errorMsg,
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    } finally {
      setDisableBtnT(false) // toujours réactiver le bouton
    }
  }

  return (
    <div className={'modal fade'} tabIndex={-1} id='kt_modal_devis' ref={modalRef}>
      <div className='modal-dialog' style={{maxWidth: '1750px', width: '95%'}}>
        <div className='modal-content'>
          <div className='modal-header'>
            <div className='d-flex align-items-center gap-12'>
              <button
                className='btn btn-sm btn-light'
                type='button'
                data-bs-target='#kt_modal_1'
                data-bs-toggle='modal'
                onClick={() => setOpenModalDevis(false)}
              >
                <i className='ki-duotone ki-arrow-left fs-3'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
                Retour au panier
              </button>
              <div className='modal-title'>
                <h5>Devis {numeroOffre}</h5>
                <span>
                  Client:{' '}
                  {client?.nomSociete ? `${client.nomSociete} - ${client.email}` : client?.email}
                </span>
              </div>
            </div>
            <div>
              <button
                type='button'
                className={`btn btn-sm ${
                  loadingPJ || fileName === '' ? 'btn-light' : 'btn-primary'
                } ${disableBtnT && 'disabled'}`}
                onClick={() => handleDownloadPdf(nomFichier)}
              >
                <IconDownload />
                <span className='mx-2'>Télécharger</span>
              </button>
              <button
                type='button'
                className='btn btn-sm btn-light-info mx-3'
                onClick={reactToPrintFn}
              >
                <IconPrint />
                <span className='mx-2'>Imprimer</span>
              </button>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
          </div>
          <div className='modal-body'>
            {isShown ? (
              <div className='d-flex gap-3' style={{fontSize: '8pt'}}>
                {displayHistory && (
                  <div
                    style={{width: '15%', maxHeight: '830px'}}
                    className={'border border-muted rounded-1 p-2 overflow-y-auto'}
                  >
                    {loadingHistoryDevis ? (
                      <div className='d-flex h-100 justify-content-center align-items-center'>
                        <span className='spinner-border spinner-border-sm align-middle ms-2 w-20px h-20px'></span>
                      </div>
                    ) : historiqueDevis?.length > 0 ? (
                      <div className='list-group list-group-flush'>
                        <h4 className='d-flex justify-content-center p-3'>
                          Liste des devis envoyés
                        </h4>
                        {historiqueDevis?.map((history, key: number) => (
                          <span
                            className={`
                            list-group-item ${
                              history?.dateCreation === null ? 'p-3' : ''
                            } list-group-item-action ${key === activeHistorique ? 'active' : ''}`}
                            style={{cursor: 'pointer'}}
                            onClick={() => setActiveHistorique(key)}
                          >
                            {history?.dateCreation !== null && (
                              <p className='fw-normal fs-5 my-1'>
                                Le {moment(history?.dateCreation).format('DD-MM-YYYY hh:mm:ss')}
                              </p>
                            )}
                            <span className=''>{history?.nomFichier ?? ''}</span>
                          </span>
                        ))}
                      </div>
                    ) : (
                      <div className='d-flex h-100 justify-content-center align-items-center'>
                        <span>Aucun devis envoyés</span>
                      </div>
                    )}
                  </div>
                )}
                {/*Affichage aperçu du fichier PDF*/}
                <PdfPreview
                  libelleList={libelleList}
                  aProposerPanier={aProposerPanier}
                  dataClientInfos={dataClientInfos}
                  demandeId={demandeId}
                  now={now}
                  dateStr={dateStr}
                  contentRef={contentRef}
                  otherData={otherData}
                  dataVehicule={dataVehicule}
                  adresseFacturation={adresseFacturation}
                  computeSources={computeSources()}
                  displayHistory={displayHistory}
                  historiqueDevis={historiqueDevis}
                  activeHistorique={activeHistorique}
                  totalDevis={totalDevis}
                  setTotalDevis={setTotalDevis}
                  retraitDepot={retraitDepot}
                  getAdresseRetraitDepot={getAdresseRetraitDepot}
                />
                {/*Formulaire personalisation d'envoie de mail*/}
                <EmailForm
                  libelleList={libelleList}
                  setHasLibelleChanged={setHasLibelleChanged}
                  dataClientInfos={dataClientInfos}
                  demandeId={demandeId}
                  now={now}
                  dateStr={dateStr}
                  panier={panier}
                  aProposerPanier={aProposerPanier}
                  setPanier={setPanier}
                  pieces={pieces}
                  setDisableBtn={setDisableBtn}
                  clientId={clientId}
                  redirectDemandeListPage={redirectDemandeListPage}
                  redirectToClientDemande={redirectToClientDemande}
                  demandeClient={demandeClient}
                  setDemandeClient={setDemandeClient}
                  setPiecesProps={setPiecesProps}
                  setLoadStock={setLoadStock}
                  lienBackend={'example.test'}
                  loadingPJ={loadingPJ}
                  fileName={fileName}
                  setOpenModalDevis={setOpenModalDevis}
                  quillRef={quillRef}
                  otherData={otherData}
                  filters={filters}
                  onResendPropo={onResendPropo}
                  setLoadingRenvoiPropos={setLoadingRenvoiPropos}
                  piecesProposeesModifiees={piecesProposeesModifiees}
                  setPiecesProposesModifiees={setPiecesProposesModifiees}
                  setCheckedPieces={setCheckedPieces}
                  piecesProposeesChecked={piecesProposeesChecked}
                  setPiecesProposeesChecked={setPiecesProposeesChecked}
                  regenerateDevisPdf={generationDevisPdF}
                  displayHistory={displayHistory}
                  historiqueDevis={historiqueDevis}
                  activeHistorique={activeHistorique}
                  totalDevis={totalDevis}
                  setInitialPieces={setInitialPieces}
                  computeSources={computeSources()}
                  mailContent={mailContent}
                  onMailContentChange={onMailContentChange}
                  commentaireInterne={commentaireInterne}
                  setCommentaireInterne={setCommentaireInterne}
                  associations={associations}
                  retraitDepot={retraitDepot}
                  handleDownloadPdf={handleDownloadPdf}
                  clientContacts={clientContacts}
                  pieceJointeSuppl={pieceJointeSuppl}
                  setPieceJointeSuppl={setPieceJointeSuppl}
                  updateAdresseFacturation={updatedFinalAdresseFactInfo}
                  updateAdresseLivraison={updatedFinalAdresseLivInfo}
                  isAdresseUpdated={isAdresseUpdated}
                  setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
                  setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
                />
              </div>
            ) : (
              <span className='d-flex justify-content-center indicator-progress'>
                Génération en cours...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-light'
              data-bs-target='#kt_modal_1'
              data-bs-toggle='modal'
            >
              Retour
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopDevis
